import { FormControl, FormLabel } from "@mui/material";

const LabelledElement = (props) => (
  <FormControl margin={"dense"} sx={{ marginBottom: "1rem" }}>
    <FormLabel
      sx={{
        marginBottom: "0.375rem",
        color: "rgba(0, 0, 0, 0.8) !important",
        fontWeight: "500",
      }}
    >
      {props.label}
    </FormLabel>
    {props.children}
  </FormControl>
);

export default LabelledElement;
